import { IState } from 'shared/store';

import { featureToggleSelector } from '../featureToggle/featureToggleSelector';
import { selectIsEarlyAccessLabelEnabled } from '../selectIsEarlyAccessLabelEnabled';

export const selectEarlyAccessContactsFlowEnabled = (state: IState): boolean =>
  Boolean(featureToggleSelector(state).earlyAccessContactsFlowEnabled && selectIsEarlyAccessLabelEnabled(state));
